// extracted by mini-css-extract-plugin
export default {"filtersConatiner":"SchoolTemplateFilters__filtersConatiner___dEaRe"};